import AppLayout from "../../components/layout/app.layout";

export const Recycle = ({}) => {
  return <AppLayout>Recycling</AppLayout>;
};
